export default __webpack_public_path__ + "static/media/icono-evaluacion.3ff77e90.jpg";